export const CreditHistoryColumns = [
  {
    accessor: "settlementMonth",
    Header: "دوره",
    header: "دوره",
    key: "settlementMonth",
  },
  {
    accessor: "totalPayable",
    Header: "مبلغ قابل پرداخت",
    header: "مبلغ قابل پرداخت",
    key: "totalPayable",
  },

  // {
  //   accessor: "creditExpirationDate",
  //   Header: "تاریخ اتمام",
  //   header: "تاریخ اتمام",
  //   key: "creditExpirationDate",
  // },
]
